// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "my-special-style" + "." + "f746683718e4f7d555db" + ".bundle.js";
};